import $ from 'jquery';
import { throttle } from 'lodash';

export default class StickToTop {
  constructor($header) {
    this.$window = $(window);
    this.$header = $header;
  }

  init() {
    if (!this.$header.length) {
      return;
    }

    const checkScroll = () => {
      this.scrollPos = this.$window.scrollTop();

      const isScrolledEnough = this.scrollPos >= this.$header.outerHeight();

      if (isScrolledEnough && !this.$header.hasClass('is-stuck')) {
        this.$header.addClass('is-stuck');
      } else if (!isScrolledEnough && this.$header.hasClass('is-stuck')) {
        this.$header.removeClass('is-stuck');
      }
    };

    checkScroll();

    this.$window.scroll(throttle(checkScroll, 300, { leading: false }));
  }
}
